import { TwitterShareButton } from "next-share";
import twitter_icon from "../assets/twitter_icon.svg";

export const TwitterShareTemplate = ({ pageUrl, pageTitle }) => {
  return (
    <TwitterShareButton url={`${pageUrl}`} quote={pageTitle} title={`${pageTitle}`}>
      <img src={twitter_icon} alt="" />
    </TwitterShareButton>
  );
};
